const toggleSideBar=(state=false,action)=>{
    switch (action.type){
        case "TOGGLESIDEBAR":
            return !state
        default:
            return state
    }
};
export default toggleSideBar;